import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const UploadIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 20 20", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "searchiconclippath" },
                React.createElement("rect", { width: "20", height: "20", fill: "white" }))),
        React.createElement("g", { clipPath: "url(#searchiconclippath)", fill: "none", strokeWidth: "2", stroke: color, strokeLinecap: "round", strokeMiterlimit: "10" },
            React.createElement("path", { d: "M7.71013 6.4502H5.10013C4.29013 6.4502 3.63013 7.1302 3.63013 7.9602V15.8802C3.63013 16.7202 4.29013 17.3902 5.10013 17.3902H14.8901C15.7001 17.3902 16.3601 16.7102 16.3601 15.8802V7.9602C16.3601 7.1202 15.7001 6.4502 14.8901 6.4502H12.3001" }),
            React.createElement("path", { d: "M10 1.58984V10.6498" }),
            React.createElement("path", { d: "M7.21997 3.87002L10.03 1.02002L12.83 3.87002" }))));
};
export default UploadIcon;
//# sourceMappingURL=index.js.map